var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-left"},[_c('div',{staticClass:"paragraph"},[_c('prismic-rich-text',{class:("mist-" + _vm.language + "-p mist-p"),attrs:{"field":_vm.content.primary.info}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }